const StatusHelper = status => {
  const STATUSES = {
    CREATED: "Created",
    IN_PROGRESS: "In Progess",
    OPENED: "Opened",
    LOAD_VERIFIED: "Load Verified",
    COMPLETED: "Completed",
    CANCELELD: "Cancelled"
  };

  return STATUSES[`${status}`] || "";
};

export default StatusHelper;



// WEBPACK FOOTER //
// ./src/components/StatusHelper.js